import { Col, Row, Typography } from "antd";
import MarkenImageComponent from "./MarkenImageComponent";

const { Title } = Typography;
const ImageRenderComponent = ({ list = [], label = '' }: { list: unknown[] | undefined | unknown, label: string | undefined }) => {
    return (
        <>
            {
                (Array.isArray(list) && list.length > 0) ?
                    <>
                        <Row wrap justify="start">
                            <Col span={24}>
                                <Title type="secondary" level={5} underline>{label}</Title>
                            </Col>
                            <MarkenImageComponent list={list} />
                        </Row>
                    </>
                    : null
            }
        </>

    )
}
export default ImageRenderComponent